export default "__VITE_ASSET__DSsjl1$q__"